import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Zones from "@/pages/Zones";
import LocalityPage from "@/pages/LocalityPage";
import About from "@/pages/About";
import { ConseilsList, ConseilArticle } from "@/pages/Conseils";
import Contact from "@/pages/Contact";
import Merci from "@/pages/Merci";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import Cookies from "@/pages/legal/Cookies";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/frelons-asiatiques" element={<ServicePage slug="frelons-asiatiques" />} />
          <Route path="/frelons-europeens" element={<ServicePage slug="frelons-europeens" />} />
          <Route path="/guepes" element={<ServicePage slug="guepes" />} />
          <Route path="/rats-et-souris" element={<ServicePage slug="rats-et-souris" />} />
          <Route path="/autres-nuisibles" element={<ServicePage slug="autres-nuisibles" />} />
          <Route path="/zones-intervention" element={<Zones />} />
          <Route path="/zone/:slug" element={<LocalityPage />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/conseils" element={<ConseilsList />} />
          <Route path="/conseils/:slug" element={<ConseilArticle />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/merci" element={<Merci />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<Confidentialite />} />
          <Route path="/gestion-cookies" element={<Cookies />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
